import type { Moment } from '../lib/moment';
import type CancelLimit from './cancel_limit2';

const CANCEL_POLICY_HEADER_PATTERN = /^【?キャンセルポリシー】?\s*\n?/;

export const stripCancelPolicyHeader = (text: string): string => {
  return text.replace(CANCEL_POLICY_HEADER_PATTERN, '');
};

const formatLimitDatetime = (limit: CancelLimit): string => {
  const formatted = limit.limitDatetime.clone().tz('Asia/Tokyo').format('YYYY年MM月DD日 HH時mm分');
  return `${formatted}（日本時間）`;
};

const formatCancelFeeLines = (limit: CancelLimit): string[] => {
  const lines: string[] = [];

  if (limit.noShow) {
    lines.push('不泊時');
  }

  if (limit.cancelFeeAmount > 0) {
    lines.push(`キャンセル料：${limit.cancelFeeAmount}円`);
  }
  if (limit.cancelFeePercent > 0) {
    lines.push(`キャンセル料（割合）：${limit.cancelFeePercent}％`);
  }
  if (limit.cancelFeeNights > 0) {
    lines.push(`キャンセル料（宿泊数）：${limit.cancelFeeNights}泊分`);
  }

  if (!limit.noShow) {
    lines.push(`キャンセル料の発生開始日時：${formatLimitDatetime(limit)}`);
  }

  return lines;
};

export const formatCancelPolicyFromLimits = (limits: CancelLimit[], _checkinDate?: Moment): string | null => {
  if (limits.length === 0) {
    return null;
  }

  const sortedLimits = [...limits].sort((a, b) => a.limitDatetime.valueOf() - b.limitDatetime.valueOf());
  const formatted = sortedLimits.map(limit => formatCancelFeeLines(limit).join('\n')).filter(Boolean);

  return formatted.length > 0 ? formatted.join('\n') : null;
};

export const resolveDisplayCancelPolicy = (args: {
  cancelLimits?: CancelLimit[];
  cancelPolicy?: string | null;
  checkinDate?: Moment;
}): string | null => {
  const { cancelLimits, cancelPolicy, checkinDate } = args;

  if (cancelLimits && cancelLimits.length > 0) {
    return formatCancelPolicyFromLimits(cancelLimits, checkinDate);
  }

  if (cancelPolicy) {
    return stripCancelPolicyHeader(cancelPolicy);
  }

  return null;
};
